function fixBtn() {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const isiPhone = /iPhone/i.test(navigator.userAgent);
  const isiPad = /iPad/i.test(navigator.userAgent);
  const buttonsSmall = document.querySelectorAll('.btn-sm');
  const buttons = document.querySelectorAll('.btn');
  const subheadings = document.querySelectorAll('.hero__subtitle');

  if (isMac || isiPhone || isiPad) {
    buttonsSmall.forEach(btn => {
      btn.classList.add('mac-fix-small')
    })

    buttons.forEach(btn => {
      btn.classList.add('mac-fix')
    })

    subheadings.forEach(subheading => {
        subheading.classList.add('subheading-mac')
    })
  } else {
    return false;
  }
}
fixBtn()
